import { createFileRoute, Navigate } from "@tanstack/react-router";
import { SCRIPT_REVIEW_ROUTE } from "@/features/marketplace/lib/preflight-report-path";

/** Legacy partner review URL — redirect into Pre Flight – Scripts. */
export const Route = createFileRoute(
  "/_authenticated/marketplace/partner/reviews/$reviewId",
)({
  component: LegacyPartnerScriptReviewRedirect,
});

function LegacyPartnerScriptReviewRedirect() {
  const { reviewId } = Route.useParams();
  return (
    <Navigate
      to={SCRIPT_REVIEW_ROUTE}
      params={{ reviewId }}
      replace
    />
  );
}
